import { useState, useEffect } from 'react';
import { CheckCircle, XCircle, RefreshCw, Eye, EyeOff, ArrowRightLeft, AlertTriangle, Clock, Save, Check } from '../../icons/wp-icons';
import { lexwareIntegrationApi } from '../../api/lexwareIntegrationApi';

const LexwareLogo = ({ className = "h-5 w-auto" }) => (
  <svg className={className} viewBox="0 0 160 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FF4554" fillRule="evenodd" clipRule="evenodd" d="M25.1185 9.61015H25.1179L25.1185 9.60898V9.61015ZM25.1179 9.61015H20.7989L20.7637 9.65472C20.1902 10.3784 19.5733 10.8592 18.4286 10.8592C16.8993 10.8592 15.7171 9.94558 15.445 8.57102H25.3999L25.4152 8.47133L25.423 8.42246C25.427 8.3974 25.4308 8.37294 25.4351 8.34936L25.4351 8.34929C25.4773 8.08778 25.5137 7.8626 25.5137 7.39702C25.5137 5.3868 24.7924 3.52552 23.4847 2.15331C22.1594 0.764684 20.338 0 18.3571 0C16.3762 0 14.5947 0.78814 13.253 2.22016C11.9793 3.58064 11.2486 5.42315 11.2486 7.27622C11.2486 11.2357 14.4692 14.4563 18.4286 14.4563C19.8407 14.4563 21.1778 14.0329 22.2931 13.233C23.4519 12.4437 24.4054 11.2474 25.0469 9.77317L25.1179 9.61015ZM15.5013 5.64599C15.9247 4.03335 17.4962 3.59823 18.3806 3.59823C19.2649 3.59823 20.8353 4.03335 21.2598 5.64599H15.5024H15.5013ZM35.4921 8.14414L32.8861 11.3612L35.0453 14.0247H36.5101H38.3855H40.2585L35.4921 8.14414ZM56.3004 0.456223H56.3931H60.5015H60.6598L60.6129 0.607518L56.5291 13.9414L56.5033 14.0247H56.4165H52.7174H52.626L52.6037 13.9367L50.4586 5.65771L48.3135 13.9367L48.2912 14.0247H48.2009H44.5006H44.4138L44.388 13.9414L40.3042 0.607518L40.2576 0.457255L35.4921 6.33678L32.8837 3.11971L35.0417 0.456223H36.5101H38.3855H40.1271H40.2573H40.2585H40.4168H44.5487H44.6413L44.6625 0.546531L46.5707 8.47836L48.6642 0.544185L48.6864 0.456223H48.7767H52.1404H52.2307L52.2542 0.543012L54.37 8.48071L56.2793 0.546531L56.3004 0.456223ZM71.4346 0.45623H71.4334H71.3173V1.67597C70.874 1.079 69.7598 0 67.4939 0C65.6772 0 63.9836 0.693141 62.7264 1.95041C61.3835 3.2933 60.6739 5.11822 60.6739 7.22814C60.6739 9.18441 61.3119 10.987 62.4683 12.3053C63.7174 13.7279 65.4555 14.4809 67.4939 14.4809C68.329 14.4809 69.1347 14.3179 69.8208 14.0083C70.4647 13.7186 70.976 13.3069 71.3162 12.8096V14.0247H75.5383V0.45623H71.4346ZM71.3173 7.22814C71.3173 8.55226 70.4588 10.5226 68.0956 10.5226C65.7323 10.5226 64.8973 8.33529 64.8973 7.27622C64.8973 6.47518 65.1752 5.66945 65.6608 5.06427C66.0654 4.55995 66.8125 3.95829 68.071 3.95829C69.6836 3.95829 71.3173 5.08186 71.3173 7.22814ZM92.8446 0C94.8255 0 96.6457 0.764684 97.971 2.15331V2.15214C99.2787 3.52435 100 5.38562 100 7.39585C100 7.8614 99.9637 8.08658 99.9214 8.34808L99.9214 8.34819C99.9156 8.38806 99.9097 8.42794 99.9027 8.47016L99.8874 8.56985H89.9324C90.2045 9.9444 91.3868 10.858 92.9161 10.858C94.0608 10.858 94.6777 10.3772 95.2512 9.65354L95.2864 9.60898H99.6059L99.5344 9.77317C98.8929 11.2474 97.9393 12.4437 96.7806 13.233C95.6652 14.0329 94.3282 14.4563 92.9161 14.4563C88.9567 14.4563 85.7361 11.2357 85.7361 7.27622C85.7361 5.42315 86.4667 3.58064 87.7404 2.22016C89.0822 0.78814 90.8637 0 92.8446 0ZM92.868 3.59823C91.9837 3.59823 90.4121 4.03335 89.9888 5.64599H89.9899H95.7473C95.3239 4.03335 93.7524 3.59823 92.868 3.59823ZM84.8764 0.019935C84.2313 0.019935 83.6179 0.129008 83.0374 0.347154C82.4557 0.5653 81.9384 0.869062 81.4846 1.25961L81.4716 0.456227H77.2506V14.0247H81.4846V6.46345C81.4846 6.03654 81.5866 5.64833 81.7907 5.29883C81.9947 4.94933 82.2715 4.67254 82.6222 4.4673C82.9717 4.26323 83.3599 4.16119 83.7868 4.16119C84.1222 4.16119 84.4495 4.2339 84.7673 4.37933L86.3752 0.238081C85.8662 0.0926503 85.3666 0.019935 84.8764 0.019935ZM31.9537 3.7765L29.262 0.456223H24.0242L26.7147 3.7765L29.5224 7.24103L26.7147 10.7044L24.0242 14.0247H29.1307H29.262L31.9537 10.7044L34.7603 7.24103L31.9537 3.7765ZM4.73822 10.0382H9.33806H9.39904H10.8979V14.0247H9.39904H9.33806H4.22218H4.1049H0.117283H0V13.9074V10.0382V0.456223H4.73822V10.0382Z" />
    <text x="103" y="12.5" style={{fontFamily: 'system-ui,-apple-system,Segoe UI,Arial,sans-serif', fontSize: '13px', fontWeight: 600, letterSpacing: '0.5px'}} fill="#FF4554">Office</text>
  </svg>
);

const FEATURE_OPTIONS = [
  { key: 'syncKontakte', label: 'Kontakte importieren', description: 'Lexware-Firmenkontakte → WerkPilot-Kunden (Duplikat-Abgleich über E-Mail/Name)', direction: '← Import' },
  { key: 'syncKunden', label: 'Kunden exportieren', description: 'WerkPilot-Kunden → Lexware-Kontakte (bei Erstellung & Update durch KI-Agenten)', direction: '→ Export' },
  { key: 'syncAnfragen', label: 'Anfragen exportieren', description: 'WerkPilot-Anfragen → Lexware-Angebote (Entwurf, bei Erstellung durch KI-Agenten)', direction: '→ Export' },
  { key: 'syncRechnungen', label: 'Rechnungen exportieren', description: 'WerkPilot-Rechnungen → Lexware-Rechnungen + Rechnungsstatus im Kundenprofil', direction: '↔ Bidirekt.' },
  { key: 'syncAngebote', label: 'KVAs/Angebote exportieren', description: 'WerkPilot-KVAs → Lexware-Angebote (mit Positionen, Preisen, Kontaktverknüpfung)', direction: '→ Export' },
];

function LexwareIntegrationSettings({ readOnly = false }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [testing, setTesting] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [showApiKey, setShowApiKey] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [syncStatus, setSyncStatus] = useState(null);
  const [logs, setLogs] = useState([]);

  const [form, setForm] = useState({
    apiKey: '',
    aktiv: false,
    syncIntervallMinuten: 60,
    syncKontakte: true,
    syncKunden: true,
    syncAnfragen: true,
    syncRechnungen: true,
    syncAngebote: true,
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [integrationRes, statusRes] = await Promise.all([
        lexwareIntegrationApi.get(),
        lexwareIntegrationApi.getStatus().catch(() => null),
      ]);

      if (integrationRes.integration) {
        setForm(prev => ({ ...prev, ...integrationRes.integration, apiKey: '' }));
      }
      if (statusRes) setSyncStatus(statusRes);

      const logsRes = await lexwareIntegrationApi.getLogs({ limit: 10 }).catch(() => ({ logs: [] }));
      setLogs(logsRes.logs || []);
    } catch (error) {
      console.error('Lexware Integration laden fehlgeschlagen:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (readOnly) return;
    setSaving(true);
    try {
      await lexwareIntegrationApi.save(form);
      await loadData();
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (error) {
      console.error('Lexware Integration speichern fehlgeschlagen:', error);
      alert('Fehler beim Speichern: ' + (error.response?.data?.error || error.message));
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      const result = await lexwareIntegrationApi.testConnection();
      setTestResult(result);
    } catch (error) {
      setTestResult({ success: false, error: error.message });
    } finally {
      setTesting(false);
    }
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      await lexwareIntegrationApi.triggerSync();
      setTimeout(loadData, 3000);
    } catch (error) {
      alert('Sync-Fehler: ' + (error.response?.data?.error || error.message));
    } finally {
      setSyncing(false);
    }
  };

  const updateForm = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  if (loading) {
    return (
      <div className="bg-surface rounded-card shadow-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <LexwareLogo className="h-5 w-auto" />
          <h2 className="text-lg font-semibold">Lexware Office Integration</h2>
        </div>
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface rounded-card shadow-card p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <LexwareLogo className="h-5 w-auto" />
          <div>
            <h2 className="text-lg font-semibold">Lexware Office Integration</h2>
            <p className="text-sm text-gray-500">
              Kunden, Rechnungen, Angebote und Anfragen automatisch synchronisieren
            </p>
          </div>
        </div>
        {syncStatus?.aktiv && (
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
            <CheckCircle className="w-3.5 h-3.5" />
            Aktiv
          </span>
        )}
      </div>

      {/* Info-Box */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Lexware Office API-Key</p>
            <p>
              Den API-Key finden Sie in Lexware Office unter{' '}
              <span className="font-medium">Einstellungen &rarr; Öffentliche API</span>.
              Erstellen Sie dort einen neuen Schlüssel mit den Berechtigungen:
              Kontakte, Rechnungen, Angebote.
              Doku: <span className="font-medium">developers.lexware.io</span>
            </p>
          </div>
        </div>
      </div>

      {/* API-Konfiguration */}
      <div className="space-y-4 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">API-Konfiguration</h3>

        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Lexware Office API-Key</label>
            <div className="relative">
              <input
                type={showApiKey ? 'text' : 'password'}
                value={form.apiKey}
                onChange={(e) => updateForm('apiKey', e.target.value)}
                placeholder="Neuen API-Key eingeben (leer lassen um bestehenden zu behalten)"
                className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary/20 focus:border-primary"
                disabled={readOnly}
              />
              <button
                type="button"
                onClick={() => setShowApiKey(!showApiKey)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showApiKey ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
        </div>

        {/* Verbindungstest */}
        <div className="flex items-center gap-3">
          <button
            onClick={handleTest}
            disabled={testing}
            className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50 flex items-center gap-2"
          >
            {testing ? (
              <RefreshCw className="w-4 h-4 animate-spin" />
            ) : (
              <ArrowRightLeft className="w-4 h-4" />
            )}
            Verbindung testen
          </button>

          {testResult && (
            <span className={`flex items-center gap-1.5 text-sm ${testResult.success ? 'text-green-600' : 'text-red-600'}`}>
              {testResult.success ? (
                <>
                  <CheckCircle className="w-4 h-4" />
                  Verbindung erfolgreich{testResult.firmenName ? ` (${testResult.firmenName})` : ''} ({testResult.dauerMs}ms)
                </>
              ) : (
                <>
                  <XCircle className="w-4 h-4" />
                  {testResult.error}
                </>
              )}
            </span>
          )}
        </div>
      </div>

      {/* Sync-Konfiguration */}
      <div className="space-y-4 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Synchronisation</h3>

        <div className="flex items-center gap-3 mb-3">
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={form.aktiv}
              onChange={(e) => updateForm('aktiv', e.target.checked)}
              className="sr-only peer"
              disabled={readOnly}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:ring-2 peer-focus:ring-primary/20 rounded-full peer peer-checked:bg-primary transition-colors"></div>
            <div className="absolute left-[2px] top-[2px] bg-white w-5 h-5 rounded-full transition-transform peer-checked:translate-x-5"></div>
          </label>
          <span className="text-sm font-medium">Automatische Synchronisation aktivieren</span>
        </div>

        <div className="w-48">
          <label className="block text-sm font-medium text-gray-700 mb-1">Sync-Intervall</label>
          <select
            value={form.syncIntervallMinuten}
            onChange={(e) => updateForm('syncIntervallMinuten', parseInt(e.target.value))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            disabled={readOnly}
          >
            <option value={30}>Alle 30 Minuten</option>
            <option value={60}>Stündlich</option>
            <option value={360}>Alle 6 Stunden</option>
            <option value={1440}>Täglich</option>
          </select>
        </div>

        {/* Feature Toggles */}
        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="text-sm font-medium text-gray-700 mb-3">Welche Daten synchronisieren?</h4>
          <div className="space-y-3">
            {FEATURE_OPTIONS.map((feature) => (
              <div key={feature.key} className="flex items-center justify-between">
                <label className="flex items-start gap-3 cursor-pointer flex-1">
                  <input
                    type="checkbox"
                    checked={form[feature.key]}
                    onChange={(e) => updateForm(feature.key, e.target.checked)}
                    className="w-4 h-4 mt-0.5 text-primary border-gray-300 rounded focus:ring-primary"
                    disabled={readOnly}
                  />
                  <div>
                    <span className="text-sm font-medium">{feature.label}</span>
                    <p className="text-xs text-gray-500">{feature.description}</p>
                  </div>
                </label>
                <span className={`text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap ml-3 ${
                  feature.direction.includes('Import') ? 'bg-blue-100 text-blue-700' :
                  feature.direction.includes('Bidirekt') ? 'bg-purple-100 text-purple-700' :
                  'bg-green-100 text-green-700'
                }`}>
                  {feature.direction}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Hinweis Lexware API-Einschränkungen */}
        <div className="text-xs text-gray-500 bg-gray-50 rounded-lg p-3">
          <p className="font-medium text-gray-600 mb-1">Hinweise zur Lexware Office API:</p>
          <ul className="list-disc list-inside space-y-0.5">
            <li>Rechnungen und Angebote sind in Lexware <span className="font-medium">nicht nachträglich änderbar</span> (kein Update). Nur die Erstanlage wird synchronisiert.</li>
            <li>Kontakte werden bei Erstellung und Update synchronisiert.</li>
            <li>Lexware hat <span className="font-medium">keine Termin-API</span> — Termine werden nicht synchronisiert.</li>
            <li>Rate Limit: max. 2 Anfragen/Sekunde. Große Syncs können einige Minuten dauern.</li>
          </ul>
        </div>
      </div>

      {/* Sync Status */}
      {syncStatus?.configured && (
        <div className="space-y-3 mb-6">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Status</h3>

          <div className="flex items-center gap-4 text-sm text-gray-600">
            {syncStatus.letzterSync && (
              <span className="flex items-center gap-1.5">
                <Clock className="w-4 h-4" />
                Letzter Sync: {new Date(syncStatus.letzterSync).toLocaleString('de-DE')}
              </span>
            )}
            <button
              onClick={handleSync}
              disabled={syncing || readOnly}
              className="px-3 py-1.5 text-xs bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50 flex items-center gap-1.5"
            >
              <RefreshCw className={`w-3.5 h-3.5 ${syncing ? 'animate-spin' : ''}`} />
              Jetzt synchronisieren
            </button>
          </div>

          {syncStatus.recentErrors?.length > 0 && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <h4 className="text-xs font-medium text-red-800 mb-2">Letzte Fehler:</h4>
              <ul className="space-y-1">
                {syncStatus.recentErrors.slice(0, 3).map((err) => (
                  <li key={err.id} className="text-xs text-red-700">
                    {err.entityTyp}: {err.fehlerNachricht}
                    <span className="text-red-400 ml-2">
                      {new Date(err.createdAt).toLocaleString('de-DE')}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {/* Letzte Sync-Logs */}
      {logs.length > 0 && (
        <div className="space-y-3 mb-6">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Sync-Protokoll</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="text-left text-gray-500 border-b">
                  <th className="pb-2 pr-3">Zeitpunkt</th>
                  <th className="pb-2 pr-3">Typ</th>
                  <th className="pb-2 pr-3">Richtung</th>
                  <th className="pb-2 pr-3">Status</th>
                  <th className="pb-2">Dauer</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {logs.map((logEntry) => (
                  <tr key={logEntry.id}>
                    <td className="py-1.5 pr-3 text-gray-600">
                      {new Date(logEntry.createdAt).toLocaleString('de-DE')}
                    </td>
                    <td className="py-1.5 pr-3">{logEntry.entityTyp}</td>
                    <td className="py-1.5 pr-3">
                      {logEntry.richtung === 'EXPORT' ? '→ Lexware' : logEntry.richtung === 'IMPORT' ? '← Lexware' : '↔'}
                    </td>
                    <td className="py-1.5 pr-3">
                      <span className={`inline-flex px-1.5 py-0.5 rounded text-xs font-medium ${
                        logEntry.status === 'SYNCHRONISIERT' ? 'bg-green-100 text-green-700' :
                        logEntry.status === 'FEHLER' ? 'bg-red-100 text-red-700' :
                        'bg-yellow-100 text-yellow-700'
                      }`}>
                        {logEntry.status}
                      </span>
                    </td>
                    <td className="py-1.5 text-gray-500">{logEntry.dauerMs ? `${logEntry.dauerMs}ms` : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Speichern */}
      {!readOnly && (
        <div className="pt-4 border-t border-border">
          {saved && (
            <div className="flex items-center gap-2 p-3 mb-4 bg-green-50 border border-green-200 text-green-700 rounded-lg text-sm">
              <Check className="w-4 h-4" />
              Lexware Office-Integration erfolgreich gespeichert
            </div>
          )}
          <button
            onClick={handleSave}
            disabled={saving}
            className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-primary text-white rounded-button font-medium hover:bg-primary-dark transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Speichern...
              </>
            ) : (
              <>
                <Save className="w-4 h-4" />
                Einstellungen speichern
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default LexwareIntegrationSettings;
